export const alignment = `<p class="text lg left">text</p>
<p class="text lg center">text</p>
<p class="text lg right">text</p>`

export const staticTxt = `<p class="text xxs">text</p>
<p class="text xs">text</p>
<p class="text sm">text</p>
<p class="text md">text</p>
<p class="text lg">text</p>
<p class="text xl">text</p>
<p class="text xxl">text</p>
<p class="text xxxl">text</p>`

export const responsiveTxt = `<p class="text responsive xl">text</p>
<p class="text responsive xxl">text</p>
<p class="text responsive xxxl">text</p>
<p class="text responsive xxxxl">text</p>`

export const color = `<p class="text md dark">dark</p>
<p class="text md light">light</p>
<p class="text md success">success</p>
<p class="text md danger">danger</p>
<p class="text md info">info</p>
<p class="text md primary">primary</p>
<p class="text md warning">warning</p>
<p class="text md secondary">secondary</p>`